<template>
    <div>
        <w-app
            :title="$t('module.validation_work_flows')"
            show-total
            :total="workFlowStore.workFlows.length"
        >

            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn
                    v-if="securityStore.authorities['UPDATE_WORKER']"
                    color="teal"
                    icon="mdi-sitemap"
                    text="Affecter WorkFlow"
                    @press="$router.push({ name: 'validation_work_flows.set_validation_work_flow' })"
                />
                <w-btn-add
                    :show="securityStore.authorities['SAVE_WORKFLOW']"
                    @press="$router.push({ name: 'validation_work_flows.add' })"
                />
            </template>

            <template v-slot:content>
                <v-skeleton-loader
                    v-show="loading"
                    ref="skeleton"
                    :type="'table'"
                    class="mx-auto"
                ></v-skeleton-loader>
                <v-data-table
                    v-show="!loading"
                    :headers="headers"
                    sort-by="name"
                    :items="workFlowStore.workFlows"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    hide-default-footer
                    @page-count="pageCount = $event"
                    dense
                    :item-class="rowColor"
                    @click:row="itemClick"
                    @dblclick:row="view"
                >
                    <template v-slot:[`item.action`]="{ item }">
                        <v-menu bottom right @click="itemClick(item)">
                            <template v-slot:activator="{ on }">
                                <v-btn dark icon color="blue darken-2" v-on="on">
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>

                            <v-list nav dense>
                                <v-list-item
                                    v-if="securityStore.authorities['UPDATE_WORKFLOW']"
                                    @click="$router.push({name: 'validation_work_flows.edit', params: { id: item.id }})"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-pencil-box-multiple'" color="orange"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        {{ $t("common.edit") }}
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="securityStore.authorities['DELETE_WORKFLOW']"
                                    @click="$router.push({name: 'validation_work_flows.delete', params: { id: item.id }})"
                                >
                                    <v-list-item-icon>
                                        <v-icon v-text="'mdi-trash-can'" color="red"></v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>
                                        {{ $t("common.delete") }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.name`]="{ item }">
                        <w-chip color="teal" :text="item.name"/>
                    </template>
                    <template v-slot:footer="{}">
                        <br/>
                        <div class="text-center">
                            <v-row justify="center">
                                <v-col md="6">
                                    <v-pagination
                                        v-model="page"
                                        :length="pageCount"
                                    />
                                </v-col>
                                <v-col md="2">
                                    <w-enum-select
                                        v-model="itemsPerPage"
                                        :items="paginationListLength"
                                        :label="$t('common.items_per_page')"
                                        @input="itemsPerPage = parseInt($event, 10)"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-data-table>
            </template>
        </w-app>

        <router-view/>
    </div>
</template>

<script>
import {useWorkFlowStore} from "@/stores/Request/WorkFlow";
import {onMounted, ref} from "vue";
import axios from "axios";
import useTools from "@/use/Tools";
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import {useSecurityStore} from "@/stores/Security";

export default {
    setup() {
        const {$i18n, $router} = useTools();
        const {
            inputColor,
            backgroundColor,
            loading,
            paginationListLength,
            itemsPerPage,
            page,
            pageCount
        } = useSharedData();
        const {itemClick, rowColor} = useSharedMethod();
        const securityStore = useSecurityStore();
        const workFlowStore = useWorkFlowStore();

        const search = ref(null);

        const  headers = [
                {
                    text: "...",
                    align: "start",
                    sortable: false,
                    value: "action",
                    width: "0%"
                },
                {
                    text: $i18n.t("common.name"),
                    align: "start",
                    sortable: true,
                    value: "name",
                },
            ];

        function findAll() {
            loading.value = true;
            axios.get('/validationWorkFlows').then((response) => {
                workFlowStore.setWorkFlows(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function view(event, {item}) {
            $router.push({name: "validation_work_flows.view", params: {id: item.id}});
        }

        onMounted(() => findAll());

        return {
            securityStore,
            workFlowStore,
            loading,
            inputColor,
            backgroundColor,
            paginationListLength,
            itemsPerPage,
            page,
            pageCount,
            headers,
            search,
            itemClick,
            rowColor,
            view,
            findAll,
        }
    },
};
</script>
